/**
 * alp-scope.js — "closest, but for Alpine stores". Generic, page-agnostic.
 *
 * Several surfaces reuse the SAME modular PDP blocks (product_title, price,
 * selector_variant, …) but need them to read a DIFFERENT product than the page:
 *   - the bundle builder (one product per slot)        → alp-bundle-scope.js
 *   - the quick-add modal (any fetched product)        → sections/quick-add-modal
 * Those blocks read $store.product / $store.selectedVariant — a single GLOBAL
 * store, addressed by name, that x-data cannot shadow per subtree.
 *
 * So we override the built-in `$store` magic with a DOM-aware version: inside a
 * scope element (any [data-product-scope] with a `__ctx`) it routes `product` /
 * `selectedVariant` to THAT element's context; everywhere else it falls through
 * to the real global store via the public Alpine.store() API. Result: stock
 * blocks work unchanged inside a scope, and root-level blocks keep hitting the
 * page's own store.
 *
 * A scope provider just needs to, in its own init():
 *     this.$root.setAttribute('data-product-scope', '');
 *     this.$root.__ctx = this;            // exposing { product, selectedVariant }
 *
 * Load (defer) BEFORE Alpine core on any page that uses a scope, so this
 * alpine:init listener registers and the magic override wins over the built-in.
 * Safe to load globally — it no-ops outside a scope. Idempotent.
 */
(function () {
  'use strict';
  if (window.__alpScope) return;
  window.__alpScope = true;

  document.addEventListener('alpine:init', function () {
    Alpine.magic('store', function (el) {
      return new Proxy({}, {
        get: function (_, name) {
          if (name === 'product' || name === 'selectedVariant') {
            var node = el.closest && el.closest('[data-product-scope]');
            if (node && node.__ctx) return node.__ctx[name];
          }
          return Alpine.store(name);
        },
      });
    });
  });
})();
